<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>
                Google analitika
                <small>
                    <p style="display: inline;" class="g-signin2" data-onsuccess="queryReports"></p>
                </small>
            </h1>
        </section>

        <!-- Main content -->
        <section class="content">
            <div class="form-inline">
                <input class="form-control" v-model="ip" placeholder="IP adresa"/>
                <input class="form-control" v-model="nickname" placeholder="Nickname"/>
                <select class="form-control" v-model="server" id="select-server">
                    <option v-if="role >= 33" value="">Server: Svi</option>
                    <option v-if="role >= 33 || role == 21" value="StartGame FFA#1">StartGame FFA#1</option>
                    <option v-if="role >= 33 || role == 21" value="Spec FFA#1">Spec FFA#1</option>
                    <option v-if="role >= 33 || role == 22" value="StartGame MINIONS#2">StartGame MINIONS#2</option>
                    <option v-if="role >= 33 || role == 22" value="Spec MINIONS#2">Spec MINIONS#2</option>
                    <option v-if="role >= 33 || role == 23" value="StartGame INSTANT MERGE#3">StartGame INSTANT MERGE#3</option>
                    <option v-if="role >= 33 || role == 23" value="Spec INSTANT MERGE#3">Spec INSTANT MERGE#3</option>
                    <option v-if="role >= 33 || role == 24" value="StartGame MEGA SPLIT#4">StartGame MEGA SPLIT#4</option>
                    <option v-if="role >= 33 || role == 24" value="Spec MEGA SPLIT#4">Spec MEGA SPLIT#4</option>
                    <option v-if="role >= 33 || role == 25" value="StartGame EXPERIMENTAL#5">StartGame EXPERIMENTAL#5</option>
                    <option v-if="role >= 33 || role == 25" value="Spec EXPERIMENTAL#5">Spec EXPERIMENTAL#5</option>
                    <option v-if="role >= 33 || role == 26" value="StartGame RAINBOW#6">StartGame RAINBOW#6</option>
                    <option v-if="role >= 33 || role == 26" value="Spec RAINBOW#6">Spec RAINBOW#6</option>
                    <option v-if="role >= 33 || role == 27" value="StartGame VIRUS MINES#7">StartGame VIRUS MINES#7</option>
                    <option v-if="role >= 33 || role == 27" value="Spec VIRUS MINES#7">Spec VIRUS MINES#7</option>
                    <option v-if="role >= 33 || role == 28" value="StartGame OLD EXP#8">StartGame OLD EXP#8</option>
                    <option v-if="role >= 33 || role == 28" value="Spec OLD EXP#8">Spec OLD EXP#8</option>
                    <option v-if="role >= 33 || role == 29" value="StartGame TOURNAMENT#9">StartGame TOURNAMENT#9</option>
                    <option v-if="role >= 33 || role == 29" value="Spec TOURNAMENT#9">Spec TOURNAMENT#9</option>
                    <option v-if="role >= 33 || role == 29" value="StartGame TOURNAMENT#10">StartGame TOURNAMENT#10</option>
                    <option v-if="role >= 33 || role == 29" value="Spec TOURNAMENT#10">Spec TOURNAMENT#10</option>
                </select>
                <input type="text" class="form-control" id="resolution" v-model="resolution" placeholder="Rezolucija npr: 1000x600">
                <button type="button" class="form-control" id="browser" @click="browserToggleClick()">{{ browserToggle() }}</button>
            </div>
            <br />
            <div class="form-inline">
                <label>Početni datum</label>
                <input type="date" class="form-control" v-model="start">

                <label style="margin-left: 15px;">Završni datum</label>
                <input type="date" class="form-control" id="endDate" v-model="end">
                <label style="margin-left: 15px;">Vreme</label>
                <input type="text" class="form-control" id="hours" v-model="hours" placeholder="00"> :
                <input type="text" class="form-control" id="minute" v-model="minute" placeholder="30">

                <button  style="margin-left: 15px;" @click="realTime()" type="button" class="btn btn-danger">Sada</button>

                <button style="margin-left: 15px;" class="btn btn-primary" @click="queryReports()" type="button" id="search">Pretraži</button>
            </div>

            <!--<textarea cols="80" rows="20" id="query-output"></textarea>-->
            <table class="table table-striped">
                <thead>
                    <tr>
                        <td>Server</td>
                        <td>Nick</td>
                        <td>IP adresa</td>
                        <td>Grad/Zemlja</td>
                        <td>Sistem</td>
                        <td>{{browserToggle()}}/Rezolucija</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="col in result">
                        <td>{{ col.dimensions[2] }}</td>
                        <td>{{ col.dimensions[1] }}</td>
                        <td>{{ col.dimensions[0] }}</td>
                        <td>{{ col.dimensions[3] }}, {{ col.dimensions[4] }}</td>
                        <td>{{ col.dimensions[5] }}, {{ col.dimensions[6] }}</td>
                        <td>{{ col.dimensions[7] }} / {{ col.dimensions[8] }}</td>
                    </tr>
                </tbody>
            </table>
        </section>
    </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    name: 'Analytic',

    data: function () {
      return {
        nickname: '',
        ip: '',
        server: '',
        result: [],
        start: '',
        end: '',
        resolution: '',
        browser: 1,
        hours: '',
        minute: '',
        role: 1
      }
    },
    computed: {
    },
    methods: {
      leadingZero: function (num) {
        var s = num + ''
        while (s.length < 2) {
          s = '0' + s
        }
        return s
      },
      browserToggle: function () {
        if (this.browser === 1) {
          return 'browser'
        }
        if (Number(this.browser) === 2) {
          return 'browserVersion'
        }
        if (Number(this.browser) === 3) {
          return 'browserSize'
        }
      },
      browserToggleClick: function () {
        if (this.browser === 1) {
          this.browser = 2
        } else if (this.browser === 2) {
          this.browser = 3
        } else if (this.browser === 3) {
          this.browser = 1
        }
      },
      realTime: function () {
        // var self = this
        var today = new Date()
        var todayString
        today.setDate(today.getDate())
        todayString = today.getFullYear() + '-' + this.leadingZero(today.getMonth() + 1) + '-' + this.leadingZero(today.getDate())
        this.start = todayString
        this.end = todayString
        this.hours = this.leadingZero(today.getHours())
        // setTimeout(function () {
        this.queryReports()
        // }, 2000)
      },
      queryReports: function () {
        var self = this
        this.result = []
        var endToSend = this.end
        var startToSend = this.start
        if (startToSend.length !== 10) {
          startToSend = '30daysAgo'
        }
        if (endToSend.length !== 10) {
          endToSend = 'today'
        }
        console.log('Pregraga....\nIP: ' + self.ip + ' | Server: ' + self.server + ' | Interval: ' + this.start + ' - ' + this.end)
        gapi.client.request({
          path: '/v4/reports:batchGet',
          root: 'https://analyticsreporting.googleapis.com/',
          method: 'POST',
          body: {
            reportRequests: [{
              viewId: '152038660',
              samplingLevel: 'LARGE',
              dateRanges: [{
                startDate: startToSend,
                endDate: endToSend
                // startDate: '30daysAgo',
                // endDate: 'today'
              }],
              metrics: [{
                expression: 'ga:uniqueEvents'
              }, {
                expression: 'ga:eventValue'
              }],

              orderBys: [
                {fieldName: 'ga:uniqueEvents', sortOrder: 'DESCENDING'}
              ],
              dimensions: [
                {
                  name: 'ga:eventLabel'
                },
                {
                  name: 'ga:eventAction'
                },
                {
                  name: 'ga:eventCategory'
                },
                {
                  name: 'ga:city'
                },
                {
                  name: 'ga:country'
                },
                {
                  name: 'ga:operatingSystem'
                },
                {
                  name: 'ga:operatingSystemVersion'
                },
                {
                  name: 'ga:' + self.browserToggle()
                },
                // {
                //   name: 'ga:browserVersion'
                // },
                {
                  name: 'ga:screenResolution'
                }
              ],
              dimensionFilterClauses: [
                {
                  filters: [{
                    dimensionName: 'ga:eventCategory',
                    operator: 'PARTIAL',
                    expressions: [self.server]
                  }
                  ]
                },
                {
                  filters: [
                    {
                      dimensionName: 'ga:eventAction',
                      operator: 'PARTIAL',
                      expressions: [self.nickname]
                    }
                  ]
                },
                {
                  filters: [
                    {
                      dimensionName: 'ga:eventLabel',
                      operator: 'PARTIAL',
                      expressions: [self.ip]
                    }
                  ]
                },
                {
                  filters: [
                    {
                      dimensionName: 'ga:screenResolution',
                      operator: 'PARTIAL',
                      expressions: [self.resolution]
                    }
                  ]
                },
                {
                  filters: [
                    {
                      dimensionName: 'ga:hour',
                      operator: 'PARTIAL',
                      expressions: [self.hours]
                    }
                  ]
                },
                {
                  filters: [
                    {
                      dimensionName: 'ga:minute',
                      operator: 'PARTIAL',
                      expressions: [self.minute]
                    }
                  ]
                }

              ]
            }]
          }
        }).then(self.displayResults, console.error.bind(console))
      },
      displayResults: function (response) {
        // var formattedJson = JSON.stringify(response.result, null, 2)
        // document.getElementById('query-output').value = formattedJson
        this.result = response.result.reports[0].data.rows
        if (!response.result.reports[0].data.rowCount) {
          alert('Nema rezultata')
        }
      }
    },
    mounted: function () {
      this.role = this.$store.state.role
      if (this.role < 33) {
        this.$router.push('/dashboard')
      }
      // this.queryReports()
      var self = this
      window.$ = $
      $(document).ready(function () {
        var priorDate = new Date()
        var startDateString

        priorDate.setDate(priorDate.getDate() - 30)
        startDateString = priorDate.getFullYear() + '-' + self.leadingZero(priorDate.getMonth() + 1) + '-' + self.leadingZero(priorDate.getDate())
        // End date
        var endDate = new Date()
        var endDateString
        endDate.setDate(endDate.getDate())
        endDateString = endDate.getFullYear() + '-' + self.leadingZero(endDate.getMonth() + 1) + '-' + self.leadingZero(endDate.getDate())
        self.start = startDateString
        self.end = endDateString
        if (self.role >= 33) {
          setTimeout(function () {
            self.queryReports()
          }, 2000)
        } else {
          setTimeout(function () {
            $('#select-server').val($('#select-server option:first').val())
            self.server = $('#select-server option:first').val()
          }, 1000)
        }
      })
    }
  }
</script>
<style>
    #hours, #minute {
        width: 40px;
    }
</style>



// WEBPACK FOOTER //
// index.vue?45bd5c46